import './item.css'
import { addStyles } from 'ethcss'
import { defaultThemeTableStyles } from 'atoms/Table/Table-theme'
import { IStyles } from '../../theme'

export const shadowButton = {
    boxShadow: '0px 4px 4px rgba(0, 54, 136, 0.25)',
}

export const blured = {
    boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.25)',
}

export const shadowSearchbar = {
    boxShadow: '2px 3px 4px 0px rgba(0, 0, 0, 0.25)',
}

export const shadowBlockTop = {
    boxShadow: '0px -4px 8px -4px rgba(0,0,0,0.25)',
}

export const shadowFull = {
    boxShadow: '0px 2px 18px 0px rgba(0,0,0,0.35)',
}

const item: IStyles = {
    sortableIcon: {
        position: 'absolute',
        right: '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        opacity: 0,
        transition: 'opacity 0.3s',
    },
    list: {
        '& li:nth-child(even)': {
            backgroundColor: `var(--var-module-ui-component-table-style-evenLine, ${defaultThemeTableStyles['evenLine']})`,
        },
    },

    listItem() {
        const self = this

        return {
            display: 'flex',
            paddingRight: '54px',
            backgroundColor: '#fff',

            '&>div': {
                display: 'flex',
                alignItems: 'center',
                padding: '10px 10px',
            },
            '& input': {
                width: '100%',
            },
            '&:hover': {
                [`& .${self.sortableIcon}`]: {
                    opacity: 1,
                },
            },
        }
    },

    header: {
        backgroundColor: `var(--var-module-ui-component-table-style-thead, ${defaultThemeTableStyles['thead']}) !important`,
    },

    caption: {
        textAlign: 'left',
        justifyContent: 'flex-start !important',
        color: `var(--var-module-ui-component-table-style-text, ${defaultThemeTableStyles['text']})`,
        fontWeight: 'bold',
    },

    choice: {
        justifyContent: 'center',
    },
}

addStyles(item)
export default item
